import type {IQCNote} from "../models/interfaces/qcNote.interface.ts";
import {withSynchronizedTagPrefix} from "../models/constants/qcProblemTags.ts";
import {formatTime} from "../utils/formatTime.ts";
import type {QCNoteRow} from "./previewQCContext.ts";

export const toQCNoteRow = (note: IQCNote): QCNoteRow => {
  const displayedText = withSynchronizedTagPrefix(note.text, note.problemTag);
  return {
    id: note.id,
    timecode: note.timecodeSeconds,
    timecodeLabel: formatTime(note.timecodeSeconds),
    text: displayedText,
    problemTag: note.problemTag,
    savedText: displayedText,
    savedProblemTag: note.problemTag,
    saved: true,
    saving: false,
    createdBy: note.createdBy,
    createdAt: note.createdAt,
  };
};

export const hasUnsavedQCNoteEdits = (note: QCNoteRow): boolean =>
  !note.saved || note.text !== note.savedText || note.problemTag !== note.savedProblemTag;

export const groupQCNoteRows = (notes: readonly IQCNote[]): Record<string, QCNoteRow[]> =>
  notes.reduce<Record<string, QCNoteRow[]>>((grouped, note) => {
    const row = toQCNoteRow(note);
    return {...grouped, [note.languageCode]: [...(grouped[note.languageCode] ?? []), row]};
  }, {});
